/** Shared date formatting for admin tables. en-GB renders September as "Sept". */

/** Date only, e.g. "5 Sept 2026". */
export function fmtDate(s?: string | null): string {
  if (!s) return '—';
  const d = new Date(s);
  return isNaN(d.getTime()) ? '—'
    : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

/** Date + 12-hour time, e.g. "5 Sept 2026 - 9:15 am". */
export function fmtDateTime(s?: string | null): string {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d.getTime())) return '—';
  const date = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const time = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
  return `${date} - ${time}`;
}

/** Legacy bookings split: { date: "Fri, Sep 5, 2026", time: "9:15 am" }. */
export function fmtBooking(s?: string | null): { date: string; time: string } {
  if (!s) return { date: '—', time: '' };
  const d = new Date(s);
  if (isNaN(d.getTime())) return { date: '—', time: '' };
  return {
    date: d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }),
    time: d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase(),
  };
}
